import memoizeOne from 'memoize-one';
import { CELL_KEY_DOWNLOAD, CELL_KEY_PREVIEW } from './constants';
const generateHeadValues = memoizeOne(columns => ({
  cells: columns.cells.map(cell => cell.key === CELL_KEY_DOWNLOAD || cell.key === CELL_KEY_PREVIEW ? {
    style: {
      width: '48px'
    },
    ...cell
  } : cell)
}));
export default memoizeOne(generateHeadValues);